// extracted by mini-css-extract-plugin
module.exports = {"error":"Error_error__2hUAM"};